import digitalData from 'digital-data';

export const cardMessaging = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@CONSUMER-CARD-MESSAGING/LOAD', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@CONSUMER-CARD-MESSAGING/LOAD is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('@@CONSUMER-CARD-MESSAGING/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@CONSUMER-CARD-MESSAGING/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('card-messaging.ready', ({ output }) => {
    const { feature = '', module = 'buy box' } = output;
    const featureStr = String(feature).toLowerCase();
    const contentModule = {
      name: module,
      feature: featureStr,
      type: 'cta'
    };
    digitalData.content = digitalData.content || {};
    digitalData.content.module = digitalData.content.module || [];
    digitalData.content.module.push(contentModule);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('card-messaging.click', ({ output }) => {
    const { feature = '', module = 'buy box' } = output;
    const featureStr = String(feature).toLowerCase();
    const contentModule = {
      name: module,
      feature: featureStr,
      type: 'cta'
    };
    const analyticsEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'content module interaction'
      },
      content: {
        module: [contentModule]
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('card-messaging.impressionEvent', ({ output }) => {
    const { feature = '', module = 'card' } = output;
    const featureStr = String(feature).toLowerCase();
    const contentModule = {
      name: module,
      feature: featureStr,
      type: 'cta'
    };
    const analyticsEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'content module impression'
      },
      eventMode: 'stash',
      content: {
        module: [contentModule]
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('card-messaging.modalImpressionEvent', ({ output }) => {
    const { feature = '' } = output;
    const featureStr = String(feature).toLowerCase();
    const analyticsEvent = {
      category: {
        primaryCategory: 'overlay'
      },
      eventInfo: {
        eventName: featureStr
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('card-messaging.modalClickEvent', ({ output }) => {
    const { feature = '' } = output;
    const featureStr = String(feature).toLowerCase();
    const analyticsEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      myAccount: {
        settings: featureStr
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });
};
